<!-- Parent.vue -->
<template>
    <div>  
        <!-- Modal import CSV -->
        <div class="modal fade bd-example-modal-xl" id="importFromCSV" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                    <div class="modal-content">
                    <div class="modal-header border-0">
                        <h5 class="modal-title" id="exampleModalCenterTitle">Import products from CSV</h5>                        
                        <button type="button" id="closeModalButton" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">   
                        <div>                            
                            <div class="p-2 d-flex">
                                    <h3 class="text-muted">Sample csv</h3>
                                    <div class="ml-2">
                                        <button class="btn btn-outline-success"
                                            @click="$exportTable('sampleTable','sampleProducts.csv')">
                                            download sample
                                        </button>	
                                    </div>
                            </div>                            
                            <table class="mt-4 table table-borderless paginate" 
                                id="sampleTable"
                                data-pagecount="3">
                                <thead >
                                    <tr>		                                                                
                                        <th scope="col" >                                    
                                            Name
                                        </th>
                                        <th scope="col">sku</th>
                                        <th>units of measure</th>
                                        <th scope="col" >
                                            Purchase price
                                        </th>
                                        <th scope="col" >
                                            Retail price
                                        </th>	
                                        <th scope="col" >
                                            Wholesale price
                                        </th>	                                       
                                        <th scope="col" >                                          
                                            Min required
                                        </th>	
                                        <th scope="col"  >                                                                                       
                                            Stock
                                        </th>	                                				
                                        <th scope="col"></th>	
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- initially selected row -->                           
                                    <tr>                                      
                                        <td>plastic Plate</td>		
                                        <td>GVUYGHKUHUG</td>     
                                        <td>pieces</td>                           
                                        <td>2000</td>
                                        <td>3000</td>																
                                        <td>2500</td>                                        
                                        <td>0</td>
                                        <td>100</td>                                                                     
                                    </tr>		
                                    <tr>                                      
                                        <td>cool T-shirt</td>		
                                        <td>TVUTG7HKUHUG</td>       
                                        <td>units</td>                         
                                        <td>300</td>
                                        <td>500</td>																
                                        <td>400</td>                                        
                                        <td>0</td>
                                        <td>100</td>                                                                     
                                    </tr>										
                                </tbody>
                            </table>
                        </div> 
                        <span class="p-4"></span>
                        <div class="d-flex flex-column">                           
                            <h3 class="text-muted">your csv</h3>
                            <h3 class="text-muted">{{get_data_status}}</h3>                                                
                            <div v-if="csv_data.length" style="height: 40vh; overflow-y: scroll">
                                <small>previewing the first 100 lines</small>
                                <table class="mt-4 table table-borderless table-responsive">
                                    <thead>
                                    <tr v-for="(data,index) in csv_data.slice(0,1)" :key="index">
                                        <th scope="col" v-for="(value,key,index) in data" :key="key">
                                            {{key}}
                                            <select class="form-control"  v-model='csv_columns[key]' :id="`column-${index}-selector`">
                                                <option selected>set as ...</option>
                                                <option >name</option>
                                                <option>category</option>
                                                <option>sku</option>
                                                <option>units of measure</option>
                                                <option>purchase price</option>
                                                <option>retail price</option>
                                                <option>wholesale price</option>
                                                <option>minimum required</option>
                                                <option>stock quantity</option>
                                            </select>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(data,index) in csv_data" :key="index">
                                        <td v-for="(value,key) in data" :key="key">{{value}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>                        
                            <small class="d-flex justify-content-start col-8 text-danger" v-if="units && ! units.length">
                                    <p>Your shop has no units of measure added
                                        <br>
                                        this is required for adding a product
                                        <br>       
                                        <span class="text-secondary">go to "Units of measure" and add one</span>
                                    </p>
                                    <br>                                                                                        
                            </small>
                            <div class="mt-3 large-12 medium-12 small-12 cell" v-if="units">
                                <label><b>file: </b>
                                <button class="mr-2 btn btn-light" v-on:click="reset()">
                                    Choose file
                                </button>
                                {{file_name}}
                                <input class="d-none" type="file" accept=".csv" id="file" ref="file"                                                                 
                                    v-on:change="handleFileUpload()"/>
                                </label>
                            </div>                            
                            <p v-if="test_csv_errors.length">
                                <ul>
                                    <small>
                                        <li v-for="(error,index) in test_csv_errors.slice(0,100)" :key="index">
                                            <p class="text-danger">{{error}}</p>
                                        </li>
                                    </small>
                                </ul>
                            </p>                            
                            <p v-if="error_500.length">
                                <ul>
                                    <small><li v-for="(error,index) in error_500" :key="index">
                                        <p class="text-danger">unexpected data format in your file, make sure your CSV or EXCEL file matches the demo</p>
                                        <p class="text-danger">select how you want to import your csv above</p>
                                    </li></small>
                                </ul>
                            </p>                       
                            </div>
                    </div>                                
                    <div class="modal-footer border-0">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>                    
                        <button type="button" class="btn btn-success"
                                v-if="csv_data.length"
                                v-on:click="checkCSV()">
                                Check CSV file
                                <span v-if = "checking_csv"
                                    class="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"></span>
                        </button>
                        <button type="button" class="btn btn-success"
                                v-if="checked && ! test_csv_errors.length && file_okay"
                                v-on:click="extractData()">
                                Extract Data
                                <span v-if = "extracting_data"
                                    class="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"></span>
                        </button>
                    </div>
                    </div>
                </div>
        </div>
    </div>
    </template>
    <script>     
    export default {
    name: 'importFromCSV',
    props:{
        units: null
    },
    data () {
        return {            
            file_name: "No file chosen",
            // csv file upload
            submitting_file: false,
            checking_csv: false,
            extracting_data: false,
            extract_data_button_text: "import data",
            file: null,
            file_okay: false,
            error_500: [],
            test_csv_errors: [],
            uploaded_file: '',
            csv_data: [],get_data_status: '',
            checked: false,
            csv_columns: {},
            requests: [],
            // papaparse config
            config:{                                                                
                delimiter: "",	// auto-detect
                newline: "",	// auto-detect
                quoteChar: '"',
                escapeChar: '"',
                header: true,
                transformHeader: undefined,
                dynamicTyping: false,
                preview: 0,        
                worker: false,
                comments: false,
                step: undefined,
                complete: undefined,
                error: undefined,                                           
                skipEmptyLines: true,
                chunk: undefined,
                fastMode: true,                           	                
            }            
        }
    },  
    methods: {        
        emitToParent () {                                     
            this.$emit('dataExtracted')
        },
        //Submits the file to the server
        previewFile: function(){    
            //preview CSV    
            var vm = this
            var config = this.config
            config.step = undefined       
            config.preview = 100
            config.complete = function(results){                
                vm.csv_data = results.data
                setTimeout(()=>{
                    for(var i in [0,1,2,3,4,5,6,7,8,9,10]){                    
                        var element = document.getElementById(`column-${i}-selector`)
                        element.value = "set as ..."                        
                    }                                  
                },200)                
            }
            this.$papa.parse(this.file, config)                                                  
        },
        // handle the case that the file changes
        handleFileUpload: function(){                                        
            this.file = this.$refs.file.files[0];            
            this.file_name = this.file.name
            this.uploaded_file = ''
            this.file_format_okay = false
            this.$refs.file.value = null            
            this.previewFile()
        },    
        // check that the csv file is of the required format
        checkCSV: function(){                
            this.test_csv_errors = []                               
            this.checking_csv = true
            //check  CSV    
            var vm = this
            var line_count = 1
            var config = this.config            
            config.preview = 0            
            //step through the csv
            config.step = function(results) {                
                //configure columns
                //check names
                var name_column = vm.$getKeyByValue(vm.csv_columns,'name')
                if (name_column){
                    var value = results.data[0][name_column]
                    if (! value.length){
                        results.errors.push(`product name can't be empty, line ${line_count}`)
                    }
                }
                else{
                    results.errors.push("product name column is required")
                }

                // check category
                var category_column = vm.$getKeyByValue(vm.csv_columns,'category')
                if (category_column){
                    //no implementation yet
                }

                // check sku
                var sku_column = vm.$getKeyByValue(vm.csv_columns,'sku')
                if (sku_column){
                   //no implementation
                }

                // check units of measure
                var units_column = vm.$getKeyByValue(vm.csv_columns,'units of measure')
                if (units_column){
                    value = results.data[0][units_column]                 
                    if(! vm.unitOfMeasureExists(value)){                        
                        results.errors.push(`units of measure ${value} does not exist for your shop, you may need to add it, line ${line_count}`)
                    }
                }
                else{
                    results.errors.push("units of measure column is required")
                }

                 // check purchase price
                 var purchase_price_column = vm.$getKeyByValue(vm.csv_columns,'purchase price')
                if (purchase_price_column){
                    value = results.data[0][purchase_price_column]
                    value.replace(/,/g, '')
                    if (isNaN(value)){
                        results.errors.push(`expected number for purchase price, line ${line_count}`)
                    }
                }
                else{
                    results.errors.push("purchase price column is required")
                }

                // check retail price
                var retail_price_column = vm.$getKeyByValue(vm.csv_columns,'retail price')
                if (retail_price_column){
                    value = results.data[0][retail_price_column]
                    value.replace(/,/g, '')
                    if (isNaN(value)){
                        results.errors.push(`expected number for retail price, line ${line_count}`)
                    }
                }
                else{
                    results.errors.push("retail price column is required")
                }

                // check wholesale price
                var wholesale_price_column = vm.$getKeyByValue(vm.csv_columns,'wholesale price')
                if (wholesale_price_column){
                    value = results.data[0][wholesale_price_column]
                    value.replace(/,/g, '')
                    if (isNaN(value)){
                        results.errors.push(`expected number for wholesale price, line ${line_count}`)
                    }
                }
                else{
                    results.errors.push("wholesale price column is required")
                }

                // check minimum required 
                var minimum_required_column = vm.$getKeyByValue(vm.csv_columns,'minimum required')
                if (minimum_required_column){
                    value = results.data[0][minimum_required_column]
                    value.replace(/,/g, '')
                    if (isNaN(value)){
                        results.errors.push(`expected number for minimum required stock level, line ${line_count}`)
                    }
                }
                else{
                    results.errors.push("'minimum required' column is required")
                }

                // check stock level
                var stock_quantity_column = vm.$getKeyByValue(vm.csv_columns,'stock quantity')
                if (stock_quantity_column){
                    value = results.data[0][stock_quantity_column]
                    value.replace(/,/g, '')
                    if (isNaN(value)){
                        results.errors.push(`expected number for stock quantity, line ${line_count}`)
                    }
                }                                                          
                vm.test_csv_errors = vm.test_csv_errors.concat(results.errors)
                line_count += 1
            }
            //on complete
            config.complete = function(){                                                     
                if (! vm.test_csv_errors.length){
                    setTimeout(()=>{
                        vm.checking_csv = false    
                        vm.checked = true
                        vm.file_okay = true
                        alert("File okay, you may proceed to extract data.")
                    },1000)                   
                }else{
                    setTimeout(()=>{
                        vm.checking_csv = false    
                        vm.checked = true  
                        vm.file_okay = false                      
                        alert("Some Errors were found in your file, please correct and try again.")
                    },1000)  
                }
            }
            this.$papa.parse(this.file, config)               
        },
        // extract data from the csv file
        // check that the csv file is of the required format
        extractData: function(){     

            this.extracting_data = true
            this.requests = []
            //check  CSV    
            var vm = this                
            var config = this.config                        
            config.preview = 0                            
            //step through the csv
            config.step = function(results) {                
                var results_data = results.data[0]                                           
                vm.requests.push(
                    //add product request
                    vm.$http({
                        method:'post',
                        url: vm.$API_BASE_URL + `/HJYBCFRB/${vm.$version}/product/`,
                        headers:{
                            Authorization: JSON.parse(localStorage.getItem('auth_token'))
                        },  
                        data: {
                            id: vm.$randID(),
                            product_type: 'n/a',
                            name: results_data[ vm.$getKeyByValue(vm.csv_columns,'name') ],
                            sku: results_data[ vm.$getKeyByValue(vm.csv_columns,'sku') ] || "n/a",
                            uom_id: vm.getUnitID(results_data[ vm.$getKeyByValue(vm.csv_columns,'units of measure') ]),
                            description: results_data[ vm.$getKeyByValue(vm.csv_columns,'description') ] || 'None given',
                            purchase_price: results_data[ vm.$getKeyByValue(vm.csv_columns,'purchase price') ],
                            retail_price: results_data[ vm.$getKeyByValue(vm.csv_columns,'retail price') ] || "n/a",
                            base_selling_price: results_data[ vm.$getKeyByValue(vm.csv_columns,'purchase price') ] || "n/a",                                        
                            wholesale_price: results_data[ vm.$getKeyByValue(vm.csv_columns,'wholesale price') ] || "n/a",
                            minimum_required: results_data[ vm.$getKeyByValue(vm.csv_columns,'minimum required') ],
                            tax: "0",
                            stock: results_data[ vm.$getKeyByValue(vm.csv_columns,'stock quantity') ] || "0",                                        
                        }                             
                    })
                )
                
            }
            //on complete
            config.complete = function(){  
                //close modal.
                document.getElementById('closeModalButton').click()         
                //update state                                 
                setTimeout(()=>{
                    vm.extracting_data = false
                    vm.$emit('alert',"Your data is being extracted in the background, This may take a while")                    
                },1000)    

                //after all requests have resolved            
                vm.axios.all(vm.requests)
                .then(
                    vm.axios.spread((...responses)=>{                        
                        vm.$emit('success',`${responses.length} products have successfully been added, go to the products tab to see your new products`)                        
                    })
                )
                .catch( (errors)=>{                    
                    alert(`some products failed to extract, check your file and try again \n error: ${errors}`)
                })   
                vm.submitting_file = false
                vm.checking_csv = false
                vm.extracting_data = false
                vm.extract_data_button_text = "import data"       
                vm.error_500 = []
                vm.test_csv_errors = []
                vm.uploaded_file = ''
                vm.csv_data = []
                vm.get_data_status = ''           
                vm.csv_columns =  {}                           
                vm.file = null
                vm.file_name = "No file chosen"                         
            }
            this.$papa.parse(this.file, config)               
        },                        
        reset: function(){        
            // csv file upload
            this.submitting_file = false
            this.checking_csv = false
            this.extracting_data = false
            this.extract_data_button_text = "import data"       
            this.error_500 = []
            this.test_csv_errors = []
            this.uploaded_file = ''
            this.csv_data = []
            this.get_data_status = ''           
            this.csv_columns =  {}                           
            this.file = null
            this.file_okay = false
            this.file_name = "No file chosen"
            document.getElementById('file').click()
        },
        //check if unit of measure exists.
        unitOfMeasureExists: function(unit){                       
            if (this.units.some(u => u.unit.toUpperCase() === unit.toUpperCase() )){                                
                return true
            }
            else{            
                return false
            }           
        },
        getUnitID(unit){            
            var this_unit =  this.units.filter((u)=>{                
                return u.unit.toUpperCase() === unit.toUpperCase()
            })                     
            return this_unit[0].id
        }
    }
    }
    </script>